<template>
  <div id="app">
    <div style="min-width: 1100px; min-height: 100%">
      <el-container>
        <el-header
          class="zztop"
          height="99"
          style="padding: 0; position: fixed; z-index: 999"
        >
          <div class="zzcontent">
            <div class="logo" @click="indexClick">
              <img src="../static/logo.png" alt="" />
              <span>最专业的书法教学平台</span>
            </div>
            <el-menu
              ref="menu"
              :default-active="activeIndex"
              class="el-menu-demo"
              :router="true"
              text-color="#666"
              active-text-color="#000"
              mode="horizontal"
              @select="handleSelect"
            >
              <el-menu-item index="/curriculum" v-if="schoolCode">
                <el-popover placement="bottom" width="40" trigger="hover">
                  <div>
                    <p
                      class="cp curriculum-hover"
                      style="
                        height: 45px;
                        line-height: 45px;
                        text-align: center;
                        border-bottom: 1px solid #ececec;
                      "
                      @click="toPath('/curriculum')"
                    >
                      专业版
                    </p>
                    <p
                      class="cp curriculum-hover"
                      style="
                        height: 45px;
                        line-height: 45px;
                        text-align: center;
                      "
                      @click="toPath('/in-school')"
                    >
                      校内版
                    </p>
                  </div>
                  <div slot="reference">全部课程</div>
                </el-popover>
              </el-menu-item>
              <el-menu-item index="/curriculum" v-if="!schoolCode"
                >全部课程</el-menu-item
              >
              <el-menu-item index="/services">商城</el-menu-item>
              <el-menu-item index="/dictionaries">字典</el-menu-item>
              <el-menu-item index="/famousPost">名帖</el-menu-item>
              <el-menu-item index="/match">赛事</el-menu-item>
              <el-menu-item index="/download">下载App</el-menu-item>
            </el-menu>
            <div class="other">
              <div class="search">
                <el-input
                  placeholder="输入课程关键词"
                  v-model="inputValue"
                  class="input-with-select"
                  @keyup.enter="search"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="search"
                  ></el-button>
                </el-input>
              </div>
              <el-popover placement="bottom" width="304" trigger="hover">
                <div style="padding: 10px">
                  <p
                    style="
                      font-size: 18px;
                      color: #333;
                      font-weight: bold;
                      margin-bottom: 27px;
                    "
                  >
                    加入会员，即可享受
                  </p>
                  <div class="r ac" style="margin-bottom: 14px">
                    <img
                      src="/static/member/icon_kecheng.png"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      alt=""
                    />
                    <span
                      style="font-size: 14px; color: #666; font-weight: bold"
                      >会员课程免费看</span
                    >
                  </div>
                  <div class="r ac" style="margin-bottom: 14px">
                    <img
                      src="/static/member/icon_youhui.png"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      alt=""
                    />
                    <span
                      style="font-size: 14px; color: #666; font-weight: bold"
                      >购课专属优惠</span
                    >
                  </div>
                  <div class="r ac" style="margin-bottom: 14px">
                    <img
                      src="/static/member/icon_dianping.png"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      alt=""
                    />
                    <span
                      style="font-size: 14px; color: #666; font-weight: bold"
                      >每月3次名师点评</span
                    >
                  </div>
                  <div class="r ac" style="margin-bottom: 33px">
                    <img
                      src="/static/member/icon_kefu.png"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      alt=""
                    />
                    <span
                      style="font-size: 14px; color: #666; font-weight: bold"
                      >1对1专属客服</span
                    >
                  </div>
                  <div class="r">
                    <div class="liaojie r ac jc cp" @click="toPath('/member')">
                      了解更多
                    </div>
                    <div
                      class="lijikaitong r ac jc cp"
                      @click="toPath('/member')"
                    >
                      立即开通会员
                    </div>
                  </div>
                </div>
                <div
                  slot="reference"
                  class="huangguan cp"
                  @click="toPath('/member')"
                  v-if="isVip"
                >
                  <img src="../static/home/huangguan.png" alt="" />
                </div>
                <div
                  slot="reference"
                  class="huangguan r ac cp"
                  @click="toPath('/member')"
                  v-if="!isVip"
                >
                  <img src="../static/home/novip.png" alt="" />
                  <span style="font-size: 18px; color: #666; margin-left: 6px"
                    >开通VIP</span
                  >
                </div>
              </el-popover>

              <div class="user cp" @click="openLogo" v-if="!isLogin">
                <img src="../static/home/logo1.png" alt="" />
                登录/注册
              </div>
              <el-popover
                v-if="isLogin"
                placement="bottom"
                width="304"
                trigger="hover"
              >
                <div style="padding: 22px 9px 15px">
                  <div class="r">
                    <el-avatar
                      :size="64"
                      :src="user.portrait"
                      fit="scale-down"
                    ></el-avatar>
                    <div class="c jc" style="margin-left: 18px; height: 64px">
                      <h4
                        style="font-size: 18px; color: #333; font-weight: 500"
                      >
                        {{ user.nickName }}
                      </h4>
                      <p style="color: #666; font-weight: 500; margin-top: 7px">
                        账号：{{ user.userName }}
                      </p>
                    </div>
                  </div>
                  <div
                    class="r jsb"
                    style="
                      margin-top: 30px;
                      margin-bottom: 13px;
                      flex-wrap: wrap;
                    "
                  >
                    <div
                      style="
                        width: 128px;
                        height: 36px;
                        border-radius: 4px;
                        background: #f1f2f4;
                        margin-bottom: 6px;
                      "
                      class="r ac jc cp"
                      @click="toPath('/mine/classList')"
                    >
                      <img
                        style="width: 15px; height: 15px; margin-right: 10px"
                        src="../static/home/icon-user-1.png"
                        alt=""
                      />
                      <span
                        style="font-size: 12px; color: #333; font-weight: 400"
                        >我的课程</span
                      >
                    </div>
                    <div
                      style="
                        width: 128px;
                        height: 36px;
                        border-radius: 4px;
                        background: #f1f2f4;
                        margin-bottom: 6px;
                      "
                      class="r ac jc cp"
                      @click="toPath('/mine/orderList')"
                    >
                      <img
                        style="width: 15px; height: 15px; margin-right: 10px"
                        src="../static/home/icon-user-2.png"
                        alt=""
                      />
                      <span
                        style="font-size: 12px; color: #333; font-weight: 400"
                        >我的订单</span
                      >
                    </div>
                    <div
                      style="
                        width: 128px;
                        height: 36px;
                        border-radius: 4px;
                        background: #f1f2f4;
                        margin-bottom: 6px;
                      "
                      class="r ac jc cp"
                      @click="toPath('/mine/scholarship')"
                    >
                      <img
                        style="width: 15px; height: 15px; margin-right: 10px"
                        src="../static/home/icon-user-3.png"
                        alt=""
                      />
                      <span
                        style="font-size: 12px; color: #333; font-weight: 400"
                        >奖 学 金</span
                      >
                    </div>
                    <div
                      style="
                        width: 128px;
                        height: 36px;
                        border-radius: 4px;
                        background: #f1f2f4;
                        margin-bottom: 6px;
                      "
                      class="r ac jc cp"
                      @click="toPath('/mine/personal')"
                    >
                      <img
                        style="width: 15px; height: 15px; margin-right: 10px"
                        src="../static/home/icon-user-4.png"
                        alt=""
                      />
                      <span
                        style="font-size: 12px; color: #333; font-weight: 400"
                        >账号设置</span
                      >
                    </div>
                  </div>
                  <div class="cp" style="color: #999" @click="signOut">
                    安全退出
                  </div>
                </div>
                <div slot="reference">
                  <el-avatar
                    :size="40"
                    :src="user.portrait"
                    fit="scale-down"
                  ></el-avatar>
                </div>
              </el-popover>
            </div>
          </div>
        </el-header>
        <el-main style="padding: 0; margin-top: 100px">
          <router-view :key="$route.fullPath" :pathValue="pathValue" />
        </el-main>
        <el-footer class="zzfooter" style="padding: 0">
          <div class="zzcontent-header">
            <div class="footer-title">
              <div class="left">
                <div class="logo">
                  <img src="../static/home/logo2.png" alt="" />
                  <span style="font-size: 12px">最专业的书法教学平台</span>
                </div>
                <div class="border"></div>
                <div class="info">
                  <span @click="toPath('/company')">关于我们</span>
                  <!-- <span>售后服务</span> -->
                  <span @click="toPath('/member')">VIP服务</span>
                  <span @click="toPath('/join')">招商加盟</span>
                </div>
                <div class="phone">
                  <span>全国服务热线：</span>
                  <img src="../static/home/phone.png" alt="" />
                  <span style="font-size: 22px; font-weight: 500"
                    >4006-878-666</span
                  >
                  <span>（在线时间：周一至周六9:00-18:00）</span>
                </div>
              </div>
              <div class="right">
                <div class="code">
                  <img src="../static/home/code.png" alt="" />
                  <span>扫码下载APP</span>
                </div>
                <div class="code">
                  <img src="../static/home/gzhcode.jpg" alt="" />
                  <span>扫码关注公众号</span>
                </div>
              </div>
            </div>
          </div>
          <div class="zzcontent-footer">
            <div class="footer-content">
              <div>
                Copyright @2022 哆来咪（北京）科技有限公司版权所有
                备案号：<a href="https://beian.miit.gov.cn/" target="_blank">京ICP备17020392号</a>
              </div>
            </div>
          </div>
        </el-footer>
        <Logo ref="modalLogo" @login="login"></Logo>
        <div class="zz-fixd">
          <div class="icon c jsa ac">
            <div class="module c jsa ac" @click="toPath('/company')">
              <div class="img img1"></div>
              <p>走进指正</p>
            </div>
            <el-popover placement="left" width="165" trigger="hover">
              <div class="code">
                <img
                  src="/static/curriculum/Bitmap.png"
                  alt=""
                  style="width: 135px; height: 135px; margin-bottom: 10px"
                />
                <p style="font-size: 14px; color: #333">扫码下载指正书法APP</p>
              </div>
              <div class="module c jsa ac" slot="reference">
                <div class="img img2"></div>
                <p>在线咨询</p>
              </div>
            </el-popover>
            <el-popover placement="left" width="200" trigger="hover">
              <div style="color: #333">
                <p style="font-size: 16px">客服热线</p>
                <p style="font-size: 18px; margin-top: 3px">4006-878-666</p>
              </div>
              <div class="module c jsa ac" slot="reference">
                <div class="img img3"></div>
                <p>官方电话</p>
              </div>
            </el-popover>
          </div>
          <div class="up r ac jc" v-if="scroll">
            <div class="img4" @click="scrollTo"></div>
          </div>
        </div>
      </el-container>
    </div>
  </div>
</template>

<script>
import Logo from "./components/logo.vue";
export default {
  name: "App",
  data() {
    return {
      pathValue: "information",
      activeIndex: "/curriculum",
      inputValue: "",
      isLogin: false,
      isVip: false,
      schoolCode: false,
      scroll: false,
      user: {},
    };
  },
  components: {
    Logo,
  },
  // 检测路由变化
  watch: {
    $route(e) {
      this.setCurrentRoute(e.path);
    },
  },
  created() {
    if (localStorage.getItem("token")) {
      this.getUserInfo();
    }
    if (localStorage.getItem("userInfo")) {
      this.isLogin = true;
      this.user = JSON.parse(localStorage.getItem("userInfo"));
    }
    if (window.location.href) {
      let str = window.location.href;
      var index = str.lastIndexOf("#");
      str = str.substring(index + 1, str.length);
      this.activeIndex = str;
    }

    document.onkeydown = (e) => {
      var key = window.event.keyCode;
      if (key == 13) {
        this.search();
      }
    };
    this.setCurrentRoute();
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    setCurrentRoute() {
      let path = this.$route.path;
      let routePath = "";
      if (this.$route.path.indexOf("curriculum") != -1) {
        routePath = "/curriculum";
      } else if (
        path.indexOf("dictionaries") != -1 ||
        path.indexOf("calligraphy") != -1 ||
        path.indexOf("chinese") != -1 ||
        path.indexOf("setword") != -1
      ) {
        routePath = "/dictionaries";
      } else if (path.indexOf("famousPost") != -1) {
        routePath = "/famousPost";
      } else if (path.indexOf("match") != -1) {
        routePath = "/match";
      }
      this.activeIndex = routePath || path; // 通过他就可以监听到当前路由状态并激活当前菜单
    },
    search() {
      this.$router.push({
        path: "/search",
        query: { content: this.inputValue },
      });
    },
    getUserInfo() {
      this.$api.getUserInfo().then((res) => {
        if (res.success) {
          this.user = res.data;
          this.isVip = res.data.isVip;
          if (res.data.schoolCode) {
            this.schoolCode = true;
          } else {
            this.schoolCode = false;
          }
          localStorage.setItem("userInfo", JSON.stringify(res.data));
        }
      });
    },
    openLogo() {
      this.$refs.modalLogo.init();
    },
    signOut() {
      localStorage.removeItem("token");
      localStorage.removeItem("userInfo");
      this.user = {};
      this.isLogin = false;
      this.isVip = false;
    },
    login(val) {
      if (val) {
        this.isLogin = true;
        this.getUserInfo();
        console.log(val);
      }
    },
    toPath(path) {
      this.$router.push({
        path: path,
      });
    },
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
    },
    scrollTo() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop =
          document.documentElement.scrollTop =
          top -=
            50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 300) {
        this.scroll = true;
      } else {
        this.scroll = false;
      }
    },

    // 点击logo
    indexClick() {
      console.log(this.$refs.menu);
      // this.$refs.menu.defaultActive = "/curriculum"
      this.toPath("/curriculum");
    },
  },
};
</script>

<style lang="less">
@font-face {
  font-family: PingFang;
  /*这里是说明调用来的字体名字*/
  src: url("../static/font/PingFang.ttf");
  /*这里是字体文件路径*/
}
#app {
  font-family: "PingFang", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background-color: #f5f5f5;
  height: 100%;
  width: 100%;
  min-width: 1200px;
  min-height: 100vh;
}
.el-menu {
  background-color: #f5f5f5 !important;
}
.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}
.el-menu--horizontal > .el-menu-item {
  font-size: 18px;
  font-weight: bold;
  border-bottom-width: 4px !important;
}
.is-active {
  border-bottom-color: #d1b07f !important;
  border-bottom-width: 4px !important;
}
.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background-color: transparent !important;
}
.el-button {
  padding: 0;
}
.el-input__inner {
  background-color: #f8f8f8;
}
.bigImgBox {
  background-image: url("/static/banner.png");
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 1920px 480px;
  width: 100vw;
  height: 480px;
  margin-bottom: 51px;
}
.curriculum-hover:hover {
  color: #d1b07f !important;
}
.liaojie {
  width: 98px;
  height: 36px;
  background: #f1f2f4;
  border-radius: 4px;
  font-size: 14px;
  font-weight: bold;
  color: #333333;
  margin-right: 10px;
}
.lijikaitong {
  width: 156px;
  height: 36px;
  background: #d1b07f;
  border-radius: 4px;
  font-size: 14px;
  font-weight: bold;
  color: #4b2b0f;
}
</style>
<style lang="less">
.zztop {
  width: 100%;
  height: 100px;
  box-shadow: 0px 1px 5px #ccc;
  background-image: url("/static/picture/headbg.png");
  .zzcontent {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100px;
    width: 1360px;

    .logo {
      padding: 24px 0;
      width: 120px;
      text-align: center;
      height: 100px;
      cursor: pointer;
      img {
        width: 120px;
        height: 30px;
      }
      span {
        font-size: 12px;
        font-weight: 500;
        color: #333333;
      }
    }

    .other {
      display: flex;
      align-items: center;
      .search {
        margin-right: 35px;
        .input-with-select {
          width: 190px;
        }
      }
      .huangguan {
        margin-right: 30px;
        img {
          width: 36px;
          height: 30px;
        }
      }
      .user {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: 500;
        color: #666666;
        img {
          width: 34px;
          height: 34px;
          margin-right: 7px;
        }
      }
    }
  }
}
.zzfooter {
  height: 340px;
  .zzcontent-header {
    background-color: #242424;
    height: 260px;
  }
  .zzcontent-footer {
    background-color: #191919;
    height: 80px;
  }
  .footer-title {
    display: flex;
    justify-content: space-between;
    height: 260px;
    width: 1200px;
    margin: 0 auto;
    .left {
      .logo {
        display: flex;
        justify-content: start;
        align-items: flex-end;
        padding-top: 46px;
        padding-bottom: 18px;
        img {
          width: 166px;
          height: 42px;
          margin-right: 15px;
        }
        span {
          font-size: 16px;
          font-weight: 400;
          color: #ffffff;
        }
      }
      .border {
        width: 722px;
        height: 1px;
        border: 1px solid #424242;
      }
      .info {
        padding-top: 25px;
        display: flex;
        justify-content: start;
        span {
          margin-right: 80px;
          font-size: 18px;
          font-weight: 400;
          color: #ffffff;
          cursor: pointer;
        }
      }
      .phone {
        padding: 43px 0;
        display: flex;
        justify-content: start;
        font-size: 18px;
        font-weight: 400;
        color: #ffffff;
        img {
          height: 24px;
          width: 24px;
          margin-right: 10px;
        }
      }
    }
    .right {
      display: flex;
      align-items: center;
      .code {
        width: 136px;
        img {
          width: 136px;
        }
        span {
          font-size: 16px;
          font-weight: 400;
          color: #ffffff;
        }
      }
      .code:first-child {
        margin-right: 20px;
      }
    }
  }
  .footer-content {
    font-size: 18px;
    font-weight: 400;
    color: #ffffff;
    line-height: 80px;
  }
}
.zz-fixd {
  position: fixed;
  top: 30%;
  right: 0;
  .icon {
    width: 100px;
    height: 345px;
    background-color: #ffffff;
    border-radius: 10px 0px 0px 10px;
    .module {
      width: 64px;
      height: 65px;
      font-size: 16px;
      font-weight: 400;
      color: #18252c;
    }
  }
  .img {
    width: 34px;
    height: 34px;
  }
  .img1 {
    background-image: url("/static/curriculum/zhizheng.png");
  }
  .img2 {
    background-image: url("/static/curriculum/zixun.png");
  }
  .img3 {
    background-image: url("/static/curriculum/phone.png");
  }
  .img1:hover {
    background-image: url("/static/curriculum/zhizheng1.png");
  }
  .img2:hover {
    background-image: url("/static/curriculum/zixun1.png");
  }
  .img3:hover {
    background-image: url("/static/curriculum/phone1.png");
  }
  .up {
    width: 100px;
    height: 101px;
    background: #ffffff;
    border-radius: 10px 0px 0px 10px;
    margin-top: 10px;
    .img4 {
      width: 49px;
      height: 49px;
      background-image: url("/static/curriculum/up.png");
    }
    .img4:hover {
      background-image: url("/static/curriculum/up1.png");
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue